/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from '../../mutation-types';
import { getApiPath } from '../../store-helpers';

const state = {
  zones: [],
};

const getters = {
  zones: state => state.zones,
};

const actions = {
  fetch({ commit }, payload) {
    Vue.http.get(`${getApiPath(payload.user)}/zones/list`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response.data);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, zones) {
    state.zones = zones.data;
  },
  [mTypes.CLEAR_STATE](state) {
    state.zones = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/products/zones.js